export const checkUserMediaCompatibility = () => {
    if(/iPhone|iPad/.test(navigator.userAgent)){
      if(!/Version\//.test(navigator.userAgent)){
        return false;
      }
    }
    return true;
}

export const checkUserMediaContrainsCompatibility = () => {
    const incompatibleDevices = [
        'SM-A305F',
        'SM-G975F',
        'SM-G610M',
        'Redmi Note 8',
        'Android 11',
        'Android 12'
    ]

    const reg = RegExp(incompatibleDevices.join('|'));
    return !reg.test(navigator.userAgent);
}


/** WEBPACK FOOTER **
 ** ./src/utils/browserUtils.js
 **/